@import 'styles/mixins';
@import 'styles/variables';

.dividerButtons {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 5px;
  padding: 0 12px 12px;
  height: 108px;

  .dividerButton {
    height: 28px;
    background: $white;
    border: 1px solid $grey-10;
    border-radius: 4px;

    &:hover {
      background: $grey-5;
    }

    .dividerButtonIcon {
      margin: auto;
    }
  }
}
